import { useAppTemplate } from "@hooks/useAppTemplate";
import LanguageLearningProgressContainer from "./LanguageLearningProgressContainer";
import TestPrepProgressContainer from "./TestPrepProgressContainer";

const ProgressContainer = () => {
	const { isLanguageLearningApp } = useAppTemplate();

	if (isLanguageLearningApp) {
		return <LanguageLearningProgressContainer />;
	}

	return <TestPrepProgressContainer />;
};

export default ProgressContainer;
